export default function toCamel(s) {
  return s.replace(/([-_\s][a-z])/gi, $1 => {
    return $1
      .toUpperCase()
      .replace("-", "")
      .replace("_", "")
      .replace("?", "")
      .replace(" ", "");
  });
}
